import { ProductsGrid } from '@wix/package-picker-autonomous';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridFeatureGroupHeader } from './GridFeatureGroupHeader';
import { GridFeatureRow } from './GridFeatureRow';
import { GridFeatureSectionHeader } from './GridFeatureSectionHeader';
import { GridHeader } from './GridHeader';

export const Grid: React.FC = () => {
  const handleClickSelect = (productId?: string) => {};
  const { t } = useTranslation();

  return (
    <ProductsGrid
      renderProductHeader={({ product, recommendedContent }) => (
        <GridHeader
          key={product.productId}
          product={product}
          recommendedContent={recommendedContent}
          onClickSelect={() => handleClickSelect(product.productId)}
        />
      )}
      renderFeatureRow={({ feature, products }) => (
        <GridFeatureRow
          key={feature.id} // TODO: Some features have duplicate ids for some reason
          feature={feature}
          products={products}
        />
      )}
      renderFeatureGroupHeader={({ group }) => (
        <GridFeatureGroupHeader group={group} />
      )}
      renderFeatureSectionHeader={({ section }) => (
        <GridFeatureSectionHeader section={section} />
      )}
      collapsibleProps={{
        foldedSectionsLabels: {
          open: t('premium-purchase-plan.show_more.CTA'),
          close: t('premium-purchase-plan.show_less.CTA'),
        },
        onShowMoreFeaturesClick: (_action) => {
          // TODO: Add BI event
        },
      }}
    />
  );
};
